import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import VueAnalytics from 'vue-analytics'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  }]
})

Vue.use(VueAnalytics, {
  id: 'UA-176496878-1',
  router
})

export default router